import { EntityHistory } from 'components/EntityHistory';
import { React } from 'libs/react';
import { useParams } from 'react-router-dom';
/**
 * @component DealChangelogPane
 * @since 1.0.0
 */
export function DealChangelogPane() {
    const { id } = useParams();
    const changesToShow = {
        QUOTE_OPENED: 'email',
        MEWS_ROUNDING: 'adjustment, billId',
        REFUNDED: 'amount, provider, reason',
        REFUND_FAILED: 'amount, error'
    };
    return (React.createElement("div", null,
        React.createElement(EntityHistory, { entity: "DEAL", entityId: id, showChanges: true, changesToShow: changesToShow })));
}
